decorateController.$inject = ["$delegate"];patchAngular.$inject = ["$compileProvider"];function _toConsumableArray(arr) {return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();}function _nonIterableSpread() {throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter) {if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);}function _arrayWithoutHoles(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;}} /** STYLES */
import 'angular-loading-bar/build/loading-bar.css';
import 'bootstrap/dist/css/bootstrap.css';
import './web_modules/snackbarjs/snackbar.min.css';
import './web_modules/chartist.custom.scss';
import './web_modules/swiper.custom.scss';
import './web_modules/datepicker/css/angular-datepicker.css';
//import 'izitoast/dist/css/iziToast.min.css'
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';

// import 'angular-google-places-autocomplete/src/autocomplete.css';
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-material-design/dist/css/ripples.min.css';
// import 'ng-dialog/css/ngDialog.css';
// import 'ng-dialog/css/ngDialog-theme-default.css';
// import 'angular-tour/dist/angular-tour.css';
// import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
// import '../../stylesheets/toolkit-light.css';
// import "../../stylesheets/g_css.scss";
// import "../../stylesheets/g_css2.scss";

/** FIRST PARTY LIBS */
import 'imports-loader?define=>false,module=>false!jquery';
import 'angular';

import { default as uiRouterModule } from "@uirouter/angularjs";
import { name as modelFactoryModule } from 'angular-model-factory-2';
// import { StickyStatesPlugin } from '@uirouter/sticky-states';
// import { DSRPlugin } from '@uirouter/dsr';

import ngCookies from 'angular-cookies';
import angularAnimateModule from "angular-animate";
import angularLoadingBar from 'angular-loading-bar';
import ocLazyLoadModule from "oclazyload";
import angularSvgRoundProgressbarModule from "angular-svg-round-progressbar";

import Chartist from 'chartist/dist/chartist';
import { Swiper, Navigation, Pagination, Scrollbar, Keyboard, EffectFlip } from 'swiper/dist/js/swiper.esm.js';
Swiper.use([Navigation, Pagination, Scrollbar, Keyboard, EffectFlip]);
import iziToast from 'izitoast/dist/js/iziToast.min.js';

window._ = require('underscore');
// window.Chart = require('imports-loader?define=>false!chart.js/dist/Chart.bundle');
// window.firebase = require('firebase');
// import firebase from 'firebase';

/** THIRD PARTY LIBS */
// require('bxslider/dist/jquery.bxslider.js');
import 'bootstrap';
import 'imports-loader?define=>false,module=>false!bxslider/dist/jquery.bxslider.js';
import 'imports-loader?define=>false,exports=>false!jquery.maskedinput/src/jquery.maskedinput';
import 'imports-loader?define=>false,exports=>false!bootstrap-datepicker/js/bootstrap-datepicker';
require('angulartics');
require('angulartics-google-analytics');
require('angular-ui-bootstrap/ui-bootstrap-tpls.js');

require('angular-messages');
require('angular-google-places-autocomplete');
require('spin.js');

require('imports-loader?define=>false!angular-spinner');
require('ng-dialog');
require('angular-sanitize');
require('angular-tour/dist/angular-tour');
require('angular-age-filter/angular-age-filter');
import './web_modules/datepicker/js/angular-datepicker.js';
import './web_modules/angular-google-autocomplete/autocomplete.js';
//import 'bootstrap-datepicker/js/bootstrap-datepicker';

import * as firebase from 'firebase';
import angularfire1 from 'angularfire1';

window.sha256 = require('js-sha256');

// require('angular-touch/angular-touch');
// require('imports-loader?define=>false!angular-chart.js/dist/angular-chart');
//
/** CUSTOMIZED LIBS */
// // require('script-loader!../vendor/materialize.min');
// require('../vendor/memorystorage.min');
import './web_modules/ngStorage_fallback_safari_private';
require('./web_modules/snackbarjs/snackbar.min.js');

window.amplitude = require('amplitude-js');

export var vendorModule = angular.module('gplans.vendor', [
uiRouterModule,
angularAnimateModule,
ocLazyLoadModule,
angularSvgRoundProgressbarModule,
modelFactoryModule,
angularLoadingBar,
ngCookies,
angularfire1,
// 'firebase',
// 'srph.age-filter',
// 'credit-cards',
'ngAutocomplete',
// 'chart.js',
'ngMessages',
'ngStorage',
// 'adSlot',
'ngCookies',
'ui.bootstrap',
'angular-loading-bar',
'ngSanitize',
'angulartics',
'angulartics.google.analytics',
'gplans.intercom',
'gplans.mixpanel',
'angular-tour',
'720kb.datepicker',
'angularSpinner']).

constant('Swiper', Swiper).
constant('Chartist', Chartist).
constant('iziToast', iziToast).
config(patchAngular).
decorator('$controller', decorateController).
config(["$uiRouterProvider", "$modelFactoryProvider", function ($uiRouterProvider, $modelFactoryProvider) {
  "ngInject";

  // $uiRouterProvider.plugin(StickyStatesPlugin);
  // $uiRouterProvider.plugin(DSRPlugin);
  $modelFactoryProvider.defaultOptions.stripTrailingSlashes = false;

  if (
  process.env.ENV === "development" &&
  localStorage.stateVisualizerEnabled)
  {
    import("@uirouter/visualizer").
    then(function (_ref) {var Visualizer = _ref.Visualizer;
      $uiRouterProvider.plugin(Visualizer);
    });
  }

}]);



function patchAngular($compileProvider) {"ngInject";
  try {
    var prevComponentVersion = $compileProvider.component;
    $compileProvider.component = function () {for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}var _args$ =
      args[0],name = _args$ === void 0 ? '' : _args$,_args$2 = args[1],definition = _args$2 === void 0 ? {} : _args$2,other = args.slice(2);
      var componentStyles = definition.styles;
      var ComponentController = definition.controller && Array.isArray(definition.controller) ?
      definition.controller[definition.controller.length - 1] :
      definition.controller;
      if (
      componentStyles &&
      ComponentController && ComponentController.prototype &&
      !ComponentController.prototype.$styles)
      {
        ComponentController.prototype.$styles = componentStyles;
      }
      return prevComponentVersion.apply($compileProvider, [name, definition].concat(_toConsumableArray(other)));;
    };
  } catch (err) {
    console.warn('patchAngular failed', err);
  }
}

function decorateController($delegate) {"ngInject";
  return function (NgController, locals) {for (var _len2 = arguments.length, other = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {other[_key2 - 2] = arguments[_key2];}
    var controller = $delegate.apply(null, [NgController, locals].concat(other));
    var componentStyles = controller.instance && controller.instance.$styles;
    if (componentStyles) {
      locals.$scope.$styles = componentStyles;
    }
    return controller;
  };
}


// Initialize the Firebase SDK
firebase.initializeApp({
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID });


iziToast.settings({
  position: 'topRight',
  progressBar: true,
  progressBarColor: 'white',
  titleColor: 'white',
  messageColor: 'white',
  color: 'blue',
  timeout: 4000,
  transitionIn: 'fadeInLeft',
  transitionOut: 'fadeOutRight',
  backgroundColor: '#03A8FD' });


window.amplitude.getInstance().init("2dab75f135621fa3b1137c6580ba52ef");

if (process.env.ENV === 'development') {

  window.$injector = function (name) {
    return angular.element(document.body).injector().get(name);
  };

  window.$apply = function (cb) {
    return angular.element(document.body).injector().get('$rootScope').$apply(cb);
  };

}


if (process.env.ENV !== "development") {

  var Raven = require('raven-js');
  var RavenAngularPlugin = require('raven-js/plugins/angular');

  Raven.
  config(window.gplansConf.ravenDSN || process.env.RAVEN_DSN, {
    environment: process.env.ENV }).

  addPlugin(RavenAngularPlugin, window.angular).
  install();

  var Raven2 = new Raven.Client();
  Raven2.
  config("https://c4dd112dbd22490a8d8917c59e693030@sentry20.d.g-plans.com/3", {
    environment: process.env.ENV }).

  addPlugin(RavenAngularPlugin, window.angular).
  install();


  angular.module('gplans.vendor').
  requires.push('ngRaven');


}